var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"candidates"},_vm._l((_vm.sortedCandidates),function(candidate){return _c('li',{key:candidate.recipient_id,class:['candidate', candidate.status]},[_c('vs-text',{staticClass:"candidate__name"},[_vm._v(_vm._s(candidate.recipient_name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }